<div class="card">
  <!--<div class="card-header">
    Kommentare...
  </div>-->
  <div class="card-block" *transloco="let loco; prefix: 'pages.comments'">
    <div class="card-text">
      <clr-tabs>
        <clr-tab>
          <button clrTabLink>{{ loco('urgent') }}</button>
          <clr-tab-content>
            <app-comment-overview [commentType]="0" [projectId]="projectId" [staffId]="staffId" [future]="false" [subId]="0" [status]="false"></app-comment-overview>
          </clr-tab-content>
        </clr-tab>
        <clr-tab>
          <button clrTabLink>{{ loco('forthcoming') }}</button>
          <clr-tab-content>
            <app-comment-overview [commentType]="0" [projectId]="projectId" [staffId]="staffId" [future]="true" [subId]="0" [status]="false"></app-comment-overview>
          </clr-tab-content>
        </clr-tab>
      </clr-tabs>
    </div>
  </div>
</div>
